<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      cell-class-name="align-top"
      row-id="expoSampleCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImage="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displaySampleName="{ row }">
        <TableLabel :value="row.sampleStyleNo" />
        <TableLabel :value="row.sampleName" />
        <TableLabel :value="row.sampleNameEn" />
      </template>
      <template v-slot:displaySample="{ row }">
        <TableLabel
          :label="$l('table_label_category') || '品类'"
          :value="row.categoryName"
        />
        <TableLabel
          :label="$l('table_label_sampleSource') || '来源'"
          :value="row.v_sampleSource"
        />
        <TableLabel
          :label="$l('table_label_sampleSpec') || '尺寸'"
          :value="`${row.sampleSpec} ${row.sampleSizeUnit || ''}`"
        />
      </template>
      <template v-slot:expoSampleStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.expoSampleStatus === 'D'
              ? 'danger'
              : row.expoSampleStatus === 'N'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_expoSampleStatus }}
        </el-tag>
      </template>
      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.expoSampleBrand" />
        <TableLabel :value="row.expoSampleName" />
      </template>
      <template v-slot:displayFabric="{ row }">
        <div v-if="row.isFabricPosition == 'Y'">
          <TableLabel
            :label="$l('table_label_faceFabric') || 'FACE'"
            :value="row.faceFabric"
          />
          <TableLabel
            :label="$l('table_label_backFabric') || 'BACK'"
            :value="row.backFabric"
          />
          <TableLabel
            :label="$l('table_label_innerFabric') || 'INNER'"
            :value="row.innerFabric"
          />
        </div>
        <div v-else>
          <TableLabel :value="row.faceFabric" />
        </div>
      </template>
      <template v-slot:displayScm="{ row }">
        <TableLabel
          :label="$l('table_label_costPrice') || '成品价格'"
          :value="`${format(row.costPrice) || '0'} ${row.costCurrency || ''}`"
        />
        <TableLabel :value="row.scmName" />
      </template>
      <template v-slot:displayQuoted="{ row }">
        <TableLabel
          :label="$l('table_label_quotedMethod') || '报价方式'"
          :value="row.quotedMethod"
        />
        <TableLabel
          :label="$l('table_label_quotedPrice') || '参考报价'"
          :value="`${format(row.quotedPrice) || '0'} ${row.currencyUnit || ''}`"
        />
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
export default {
  mixins: [EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      format: (n) => format(n),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'audit':
        case 'change':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'delete':
          this.del(data)
          break
        case 'printer':
          this.$emit('printer', data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async del({ expoSampleMeetingCode }) {
      const confirm = await this.$confirm(
        this.$l('confirm_delExpoSample') || '是否要删除该会议选品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.loadingOpen()
      const res = await this.$api
        .expoSampleMeetingDelApi({ expoSampleMeetingCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImage', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
